<template>
  <div class="connector-flow">
    <div class="header">
      <div class="text">
        <h1>我的连接流</h1>
        <span>可视化配置建流方式实现不同系统之间数据互通</span>
      </div>
      <div class="btns">
        <el-input prefix-icon="el-icon-search" style="width: 200px; margin-right: 15px" placeholder="查找" v-model="actionName" clearable @change="onChange"></el-input>
        <el-button type="primary" class="el-icon-plus" @click="onAddClick"> 创建连接器</el-button>
      </div>
    </div>
    <el-tabs v-model="activeName" class="md-tabs" @tab-click="handleClick">
      <el-tab-pane label="自建流" name="self">
        <self-flow></self-flow>
      </el-tab-pane>
      <el-tab-pane label="官方流" name="official">
        <official-flow></official-flow>
      </el-tab-pane>
      <el-tab-pane label="三方流" name="trilateral">
        <trilateral-flow></trilateral-flow>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import SelfFlow from "./flow/self-flow.vue";
import OfficialFlow from "./flow/official-flow";
import TrilateralFlow from "./flow/trilateral-flow";
export default {
  name: "connector-flow",
  props: {},
  components: { SelfFlow, OfficialFlow, TrilateralFlow },
  data() {
    return {
      activeName: "self",
      actionName: "",
    };
  },
  methods: {
    handleClick() {},
    onChange() {},
    onAddClick() {},
  },
};
</script>
<style scoped lang="scss">
.connector-flow {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  height: 50px;
  display: flex;
  justify-content: space-between;
}

.header h1 {
  display: inline-block;
  color: #262626;
}
.header span {
  font-size: 14px;
  color: #919191;
  margin-left: 10px;
}
</style>
